import { createAppSlice } from "../../app/createAppSlice"
import createEvidenceDisplay from "../../resourceComponents/compositionResourceFunctions/createEvidenceDisplay"
import getIdFromReference from "../../functions/getIdFromReference"

const addToEvidenceDisplayDictionary = (item, evidenceDisplayDictionary) => {
    let evidenceDisplay = createEvidenceDisplay(item);
    evidenceDisplayDictionary[item.id] = evidenceDisplay;
};

const createEvidenceTableMap = (body) => {
    let foi = body.foi;
    let parentResourceDetail = body.parentResourceDetail;
    let resourceCollection = body.resourceCollection;
    let resourceJson = parentResourceDetail?.revisedResourceJson || parentResourceDetail?.resourceJson;
    if (resourceJson.id) {
        let evidenceTableMap = {
            "compositionId": foi,
            "compositionTitle": resourceJson.title || resourceJson.name || parentResourceDetail.displayTitle
        };
        let resultsSectionsKeys = [];
        let resultsSectionsDictionary = {};
        let resourceDictionary = {};
        let containedDictionary = {};
        let combinedDictionary = {};
        let groupReferencesDictionary = {};
        let groupReferencesDefinedInGroupList = false;
        let evidenceDisplayDictionary = {};
        let picoClassifiers = {};
        let populationArray = [];
        let interventionArray = [];
        let comparatorArray = [];
        let outcomeArray = [];
        if (Array.isArray(resourceJson.useContext) && resourceJson.useContext.length > 0) {
            for (const item of resourceJson.useContext) {
                const code = item?.code.code;
                if (code === "population" && item.valueCodeableConcept) {
                    populationArray.push({"concept": item.valueCodeableConcept});
                }
                else if (code === "intervention" && item.valueCodeableConcept) {
                    interventionArray.push({"concept": item.valueCodeableConcept});
                }
                else if (code === "comparator" && item.valueCodeableConcept) {
                    comparatorArray.push({"concept": item.valueCodeableConcept});
                }
                else if (code === "outcome-measure" && item.valueCodeableConcept) {
                    outcomeArray.push({"concept": item.valueCodeableConcept});
                }
            }
        }
        if (Array.isArray(resourceJson.classification) && resourceJson.classification.length > 0) {
            for (const item of resourceJson.classification) {
                const code = item?.type?.coding?.[0]?.code;
                if (code === "population" && item.classifier) {
                    populationArray = item.classifier;
                }
                else if (code === "intervention" && item.classifier) {
                    interventionArray = item.classifier;
                }
                else if (code === "comparator" && item.classifier) {
                    comparatorArray = item.classifier;
                }
                else if (code === "outcome-measure" && item.classifier) {
                    outcomeArray = item.classifier;
                }
            }
        }
        picoClassifiers = {
            populationArray: populationArray,
            interventionArray: interventionArray,
            comparatorArray: comparatorArray,
            outcomeArray: outcomeArray
        };
        if (Array.isArray(resourceJson.section) && resourceJson.section.length > 0) {
            for (const sectionIndex in resourceJson.section) {
                const section = resourceJson.section[sectionIndex];
                const sectionPath = [sectionIndex];
                const sectionPathString = sectionPath.join(",");
                if (section?.code?.coding?.[0]?.code === "results" && section.entry?.length > 0) {
                    resultsSectionsKeys.push(sectionPathString);
                    resultsSectionsDictionary[sectionPathString] = section;
                } else if (section?.code?.text === "OutcomeGroupList" ||
                    section?.code?.text === "BaselineGroupList" ||
                    section?.code?.text === "FlowGroupList" ||
                    section?.code?.text === "GroupList"
                ) {
                    if (section.entry?.length) {
                        for (let entry of section.entry) {
                            let entryId = getIdFromReference(entry);
                            if (!groupReferencesDictionary[entryId]) {
                                groupReferencesDictionary[entryId] = entry;
                            }
                        }
                    }
                } else {
                    if (section?.section?.length > 0) {
                        let sectionFocus = section.focus;
                        for (const subsectionIndex in section.section) {
                            const subsection = section.section[subsectionIndex];
                            const subsectionPath = sectionPath.concat([subsectionIndex]);
                            const subsectionPathString = subsectionPath.join(",");
                            if (subsection?.code?.coding?.[0]?.code === "results") {
                                if (!subsection.focus && sectionFocus) {
                                    subsection.focus = sectionFocus;
                                }
                                resultsSectionsKeys.push(subsectionPathString);
                                resultsSectionsDictionary[subsectionPathString] = subsection;
                            } else if (subsection?.code?.text === "OutcomeGroupList" ||
                                subsection?.code?.text === "BaselineGroupList" ||
                                subsection?.code?.text === "FlowGroupList" ||
                                section?.code?.text === "GroupList"
                            ) {
                                if (subsection.entry?.length) {
                                    for (let entry of subsection.entry) {
                                        let entryId = getIdFromReference(entry);
                                        if (!groupReferencesDictionary[entryId]) {
                                            groupReferencesDictionary[entryId] = entry;
                                        }
                                    }
                                }
                            } else {
                                if (subsection.focus) {
                                    sectionFocus = subsection.focus;
                                }
                                if (subsection?.section?.length > 0) {
                                    for (const subsubsectionIndex in subsection.section) {
                                        const subsubsection = subsection.section[subsubsectionIndex];
                                        const subsubsectionPath = subsectionPath.concat([subsubsectionIndex]);
                                        const subsubsectionPathString = subsubsectionPath.join(",");
                                        if (subsubsection?.code?.coding?.[0]?.code === "results") {
                                            if (!subsubsection.focus && sectionFocus) {
                                                subsubsection.focus = sectionFocus;
                                            }
                                            resultsSectionsKeys.push(subsubsectionPathString);
                                            resultsSectionsDictionary[subsubsectionPathString] = subsubsection;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (Object.keys(groupReferencesDictionary).length > 0) {
                groupReferencesDefinedInGroupList = true;
            }
        }
        for (const entry of resourceCollection) {
            resourceDictionary[entry.id] = entry.revisedResourceJson;
            if (entry.resourceType === "Evidence") {
                addToEvidenceDisplayDictionary(entry.revisedResourceJson, evidenceDisplayDictionary);
                if (!groupReferencesDefinedInGroupList) {
                    if (entry.revisedResourceJson.meta?.profile?.[0] === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence" &&
                        entry.revisedResourceJson.variableDefinition?.[1]?.variableRole === "exposure") {
                        let referenceObject = entry.revisedResourceJson.variableDefinition[1].observed || entry.revisedResourceJson.variableDefinition[1].intended;
                        let entryId = getIdFromReference(referenceObject);
                        if (!groupReferencesDictionary[entryId]) {
                            groupReferencesDictionary[entryId] = referenceObject;
                        }
                    } else if (entry.revisedResourceJson.variableDefinition?.[0]?.variableRole === "population") {
                        let referenceObject = entry.revisedResourceJson.variableDefinition[0].observed || entry.revisedResourceJson.variableDefinition[0].intended;
                        let entryId = getIdFromReference(referenceObject);
                        if (!groupReferencesDictionary[entryId]) {
                            groupReferencesDictionary[entryId] = referenceObject;
                        }
                    }
                }
            }
            combinedDictionary[entry.id] = entry.revisedResourceJson;
        }
        if (Array.isArray(resourceJson.contained) && resourceJson.contained.length > 0) {
            for (const item of resourceJson.contained) {
                containedDictionary[item.id] = item;
                if (item.resourceType === "Evidence") {
                    addToEvidenceDisplayDictionary(item, evidenceDisplayDictionary);
                    if (!groupReferencesDefinedInGroupList) {
                        if (item.meta?.profile?.[0] === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence" &&
                            item.variableDefinition?.[1]?.variableRole === "exposure") {
                            let entry = item.variableDefinition[1].observed || item.variableDefinition[1].intended;
                            let entryId = getIdFromReference(entry);
                            if (!groupReferencesDictionary[entryId]) {
                                groupReferencesDictionary[entryId] = entry;
                            }
                        } else if (item.variableDefinition?.[0]?.variableRole === "population") {
                            let entry = item.variableDefinition[0].observed || item.variableDefinition[0].intended;
                            let entryId = getIdFromReference(entry);
                            if (!groupReferencesDictionary[entryId]) {
                                groupReferencesDictionary[entryId] = entry;
                            }
                        }
                    }
                }
                combinedDictionary[item.id] = item;
            }
        }
        let outcomeGroupsQuantityDictionary = {};
        for (let groupId of Object.keys(groupReferencesDictionary)) {
            if (groupId.split("/").length === 2) {
                groupId = groupId.split("/")[1];
            }
            if (combinedDictionary[groupId]?.quantity ||
                combinedDictionary[groupId]?.quantity === 0) {
                outcomeGroupsQuantityDictionary[groupId] = combinedDictionary[groupId].quantity;
            }
        }
        evidenceTableMap["combinedDictionary"] = combinedDictionary;
        evidenceTableMap["groupReferencesDictionary"] = groupReferencesDictionary;
        evidenceTableMap["resultsSectionsDictionary"] = resultsSectionsDictionary;
        evidenceTableMap["resultsSectionsKeys"] = resultsSectionsKeys;
        evidenceTableMap["evidenceDisplayDictionary"] = evidenceDisplayDictionary;
        evidenceTableMap["outcomeGroupsQuantityDictionary"] = outcomeGroupsQuantityDictionary;
        evidenceTableMap["picoClassifiers"] = picoClassifiers;
        return evidenceTableMap;
    }
}

const initialState = {
    "compositionId": "",
    "compositionTitle": "",
    "groupReferencesDictionary": {},
    "resultsSectionsDictionary": {},
    "resultsSectionsKeys": [],
    "combinedDictionary": {},
    "evidenceDisplayDictionary": {},
    "outcomeGroupsQuantityDictionary": {},
    "picoClassifiers": {}
};

const evidenceTableMapSlice = createAppSlice({
    name: "evidenceTableMap",
    initialState,
    reducers: create => ({
        changeEvidenceTableMap: create.reducer((state, action) => {
            let interimbody = action.payload;
            let body = createEvidenceTableMap(interimbody);
            state.compositionId = body.compositionId;
            state.compositionTitle = body.compositionTitle;
            state.resultsSectionsKeys = body.resultsSectionsKeys;
            state.resultsSectionsDictionary = body.resultsSectionsDictionary;
            state.outcomeGroupsQuantityDictionary = body.outcomeGroupsQuantityDictionary;
            state.groupReferencesDictionary = body.groupReferencesDictionary;
            state.combinedDictionary = body.combinedDictionary;
            state.evidenceDisplayDictionary = body.evidenceDisplayDictionary;
            state.picoClassifiers = body.picoClassifiers;
        }),
    }),
    selectors: {
        selectEvidenceTableMap: evidenceTableMap => evidenceTableMap
    },
})

export const { changeEvidenceTableMap } = evidenceTableMapSlice.actions

export const { selectEvidenceTableMap } = evidenceTableMapSlice.selectors

export default evidenceTableMapSlice